import BackButton from "@/components/BackButton";

export default function PageHeader({ title, actions, testId, backTo, backLabel, eyebrow }) {
    return (
        <div className="page-header flex flex-col gap-3 md:flex-row md:items-end md:justify-between border-b border-border pb-5 mb-6" data-testid={testId}>
            <div className="min-w-0">
                {backTo && <BackButton to={backTo} label={backLabel || "Back"} />}
                <div className="space-y-1">
                    {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.16em] text-muted-foreground">{eyebrow}</p>}
                    <h1 className="font-display text-2xl md:text-3xl font-semibold tracking-tight">{title}</h1>
                </div>
            </div>
            {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
        </div>
    );
}
